<template>
  <QTable
    :columns="columns"
    hide-bottom
    :rows="rows"
  >
    <template #header>
      <QTr>
        <QTh class="text-left"> Field </QTh>
        <QTh class="text-left"> From </QTh>
        <QTh class="text-left"> To </QTh>
      </QTr>
    </template>

    <template #body="props">
      <QTr :props="props">
        <QTd
          key="field"
          :props="props"
        >
          {{ props.row.field }}
        </QTd>
        <QTd
          key="from"
          class="wrap-table-content vertical-top"
          :props="props"
        >
          {{ props.row.from }}
        </QTd>
        <QTd
          key="to"
          class="wrap-table-content vertical-top"
          :props="props"
        >
          {{ props.row.to }}
        </QTd>
      </QTr>
    </template>
  </QTable>
</template>

<script>
import { toSentence } from "shared/helpers/array";

export default {
  name: "VersionControlItemChangesTable",
  props: {
    changes: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        {
          name: "field",
          required: false,
          label: "Field",
          field: "field",
          align: "left",
          style: "width: 20%",
          classes: "wrap-table-content",
        },
        {
          name: "from",
          required: false,
          label: "From",
          field: "from",
          align: "left",
          style: "width: 40%",
          classes: "wrap-table-content",
        },
        {
          name: "to",
          required: false,
          label: "To",
          field: "to",
          align: "left",
          style: "width: 40%",
          classes: "wrap-table-content",
        },
      ],
    };
  },
  computed: {
    rows() {
      const rows = [];

      Object.keys(this.changes).forEach((key) => {
        if (key === "updated_at") return;

        rows.push({
          field: key,
          from: this.objectChangesInSentence(this.changes[key][0]),
          to: this.objectChangesInSentence(this.changes[key][1]),
        });
      });

      return rows;
    },
  },
  methods: {
    objectChangesInSentence(change) {
      return Array.isArray(change) ? toSentence(change) : change;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap-table-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
